import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.192 6.808A13 13 0 0 0 8.026 5.733l-.26.207-.253.213a13 13 0 0 0-3.017 15.9l.107.196-1.069 3.744-.04.162a2 2 0 0 0 .549 1.802l.123.113.13.101a2 2 0 0 0 1.711.295l3.742-1.07.198.108.293.15A13 13 0 0 0 25.192 6.808m-15.94.505a11 11 0 0 1 15.435 15.434l-.188.236-.197.233A11 11 0 0 1 10.65 25.61l-.329-.188-.108-.046a1 1 0 0 0-.61-.018l-4.146 1.185 1.185-4.147.028-.133a1 1 0 0 0-.13-.652A11 11 0 0 1 9.253 7.313M20 17.05a1 1 0 0 1 .117 1.993L20 19.05h-8a1 1 0 0 1-.117-1.993L12 17.05zm1-3a1 1 0 0 0-1-1h-8l-.117.007A1 1 0 0 0 12 15.05h8l.117-.007A1 1 0 0 0 21 14.05"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconComments = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconComments);
export default Memo;
